import { useNavigate } from 'react-router-dom';
import { Modal, Form, Input, Upload, Select } from 'antd';
import { usePostProjectMutation } from '../features/api/apiSlice';
import { InboxOutlined } from '@ant-design/icons';

export default function CreateProjectForm(props) {
  const { open, setOpen } = props;
  const [postProject, { isLoading }] = usePostProjectMutation();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const handleCreate = () => {
    form
      .validateFields()
      .then(async (values) => {
        const { title, description, dragger } = values;
        const zip = Array.isArray(dragger) ? dragger[0] : {};

        const data = await postProject({ title, description, zip: zip?.response?.zip }).unwrap();
        form.resetFields();

        setOpen(false);
        navigate(`/projects/${data.id}/map`);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const normFile = (e) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const onFileRemove = (file) => {
    console.log(file.response);
  };

  const fileTypeOptions = [
    { label: 'True Coordinates DWG', value: 'coordinatesDWG' },
    { label: 'Geo-located DWG', value: 'geoDWG' },
    { label: 'Shape ZIP', value: 'spapeZIP' },
  ];

  return (
    <Modal
      open={open}
      title="New project"
      okText="Create"
      onCancel={() => {
        form.resetFields();
        setOpen(false);
      }}
      centered
      onOk={handleCreate}
      okButtonProps={{
        loading: isLoading,
      }}
      styles={{
        body: {
          maxHeight: 'calc(90vh - 120px)',
          overflow: 'hidden',
        },
        header: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 16,
          fontWeight: 600,
          fontSize: 18,
        },
        footer: {
          display: 'flex',
          justifyContent: 'end',
          gap: 16,
          alignItems: 'center',
          padding: 8,
        },
      }}
    >
      <Form
        form={form}
        layout="vertical"
        style={{
          maxHeight: 'calc(90vh - 120px)',
          overflowY: 'auto',
          padding: 24,
        }}
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[
            {
              required: true,
              message: 'Please input the title of a new project',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input type="textarea" />
        </Form.Item>
        <Form.Item rules={[{ required: true }]} pattern="[0-9]{1-10}" name="epsg" label="EPSG">
          <Input placeholder="e.g. '28992' for RD New / '3857' for Web Mercator" />
        </Form.Item>
        <Form.Item name="filetype" label="File Type">
          <Select options={fileTypeOptions} defaultValue="coordinatesDWG" />
        </Form.Item>
        <Form.Item label="Drawings">
          <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
            <Upload.Dragger
              maxCount={1}
              onRemove={onFileRemove}
              accept=".dwg,.zip"
              name="file"
              action={`${process.env.REACT_APP_API_URI}/uploads`}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag zip archive or dwg file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Archive must contain .shp, .shx, and .dbf files for every layer.
              </p>
            </Upload.Dragger>
          </Form.Item>
        </Form.Item>
      </Form>
    </Modal>
  );
}
